<template>
  <button
    v-once
    type="button"
    class="btn btn-light btn-block border-0 rounded-0"
    @click="$emit('click', $event)"
  >
    <i class="fas fa-plus" />
  </button>
</template>

<script>
export default {};
</script>
